module.exports = __webpack_public_path__ + "static/media/check.2c6805d4.svg";